import { createStore } from 'vuex'

export default createStore({
  state: {
    isLoading: false
  },
  getters: {
    isLoading: state => state.isLoading
  },
  mutations: {
    SET_LOADING(state, status) {
      state.isLoading = status
    }
  },
  actions: {
    setLoading({ commit }, status) {
      commit('SET_LOADING', status)
    }
  },
  modules: {
  }
})
